import {ExternalLinkModalProps} from "../../types";
import {Modal, Spin} from "antd";
import {useMemo} from "react";
import ExternalLinkForm from "./components/externalLink-form/ExternalLinkForm";


const ExternalLinkModal = (props: ExternalLinkModalProps) => {
  const {externalLinksController} = props
  const {isLoading, isModalOpen, form, selectedExternalLink, toggleModal} = externalLinksController
  const title = useMemo(() => {

    return selectedExternalLink ? "Редагувати посилання на ресурс" : "Додати посилання на ресурс"

  }, [selectedExternalLink])


  return (<Modal width={600} style={{top: 20}} title={title} open={isModalOpen} onOk={() => {
    form.submit()
  }}
                 onCancel={toggleModal}
                 cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <ExternalLinkForm externalLinksController={externalLinksController}/>
    </Spin>
  </Modal>)
}

export default ExternalLinkModal